"use client";
import React from "react";
import { onNextFrame } from "../../utilities/animation.js";
import { classNames } from "../../utilities/helpers.js";
import s from "./Expandable.module.css";
const Expandable = (props) => {
    const { children, active, attributes } = props;
    const [animated, setAnimated] = React.useState(false);
    const rootClassNames = classNames(s.root, active && s["--active"]);
    const handleTransitionEnd = (e) => {
        if (e.propertyName !== "height")
            return;
        onNextFrame(() => {
            setAnimated(false);
        });
    };
    React.useEffect(() => {
        setAnimated(active || false);
    }, [active]);
    return (React.createElement("div", { ...attributes, className: rootClassNames, onTransitionEnd: handleTransitionEnd, role: "region", hidden: !active && !animated },
        React.createElement("div", { className: s.inner }, children)));
};
export default Expandable;
